import React, {Component} from 'react';
import {Button, Col, InputGroup, Label, Row} from "reactstrap";
import {observer} from "mobx-react";
import moment from 'moment';
import FormDatePicker from "../../../comum/components/FormDatePicker";
import SelectFiltro from "../../../comum/components/SelectFiltro";
import lscache from 'lscache';
import Card from '../../../comum/components/Card';

@observer
export default class FiltrosAgendamentoDashboard extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.state = {filtrado: false}

        let dataAgendamento = lscache.get(`dashboard-data`);
        this.dataFiltroTela = dataAgendamento ? moment(dataAgendamento) : moment();
    }

    componentDidMount() {
        let dataAgendamento = lscache.get(`dashboard-data`);
        let fainaAgendamento = lscache.get(`dashboard-faina`);

        this.dataFiltroTela = dataAgendamento ? dataAgendamento : moment();

        if (dataAgendamento){
            this.handleDataChange(dataAgendamento);
        }
        if (fainaAgendamento){
            this.controller.setTipo(fainaAgendamento);
        }
        this.filtrar()
    }

    filtrar(){
        this.setState(state => ({filtrado: true}));
        this.controller.carregarLista();
    }

    handleDataChange(event) {
        let dataFiltro;
        if (event.target)
        {
            dataFiltro = moment(event.target.value).add(0, 'day').format("YYYY-MM-DD");
        }
        else if (event)
        {
            dataFiltro = moment(event).add(0, 'day').format("YYYY-MM-DD");
        }
        
        this.controller.setDataConsulta(dataFiltro);
    }

    render() {
        return (
            <Card>
                <div className="filtros">
                    <Row className="pb-0">
                        <SelectFiltro xl={3} lg={4} md={6} sm={6} xs={12} className="px-0 ml-2" 
                                      titulo="Tipo"
                                      itens={this.controller.tiposAgendamento}
                                      valor={this.controller.tiposPreenchido}
                                      itensValor="Id" itensLabel="DscFaina"
                                      onChange={this.controller.setTipo} 
                        />
                        <Col className="mb-0 mt-3" xl={3} lg={4} md={6} xs={12} >
                            
                                    <FormDatePicker 
                                                    titulo="Data Consulta"
                                                    date={this.dataFiltroTela}
                                                    uniqueId="DataConsulta"
                                                    onChange={(event) => this.handleDataChange(event)}
                                                />  
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.filtrar()}>Filtrar</Button>
                        </Col> 
                    </Row>
                </div>
            </Card>
        )
    }
}




// WEBPACK FOOTER //
// ./src/modules/agendamento/dashboard/componentes/FiltrosAgendamentoDashboard.js